import { render, staticRenderFns } from "./BuildsMenu.vue?vue&type=template&id=42724f44&scoped=true&"
import script from "./BuildsMenu.vue?vue&type=script&lang=js&"
export * from "./BuildsMenu.vue?vue&type=script&lang=js&"
import style0 from "./BuildsMenu.vue?vue&type=style&index=0&id=42724f44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42724f44",
  null
  
)

export default component.exports